import { render, staticRenderFns } from "./msLoading.vue?vue&type=template&id=3f71bfc4&scoped=true"
import script from "./msLoading.vue?vue&type=script&lang=js"
export * from "./msLoading.vue?vue&type=script&lang=js"
import style0 from "./msLoading.vue?vue&type=style&index=0&id=3f71bfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71bfc4",
  null
  
)

export default component.exports